import { IWidgetNode } from "./interfaces/widget-node.interface";
import { WidgetState } from "./components/widget-state";
import { WidgetStatus } from "./enums/widget-status.enum";
import { WidgetEvent } from "./enums/widget-event.enum";
import { IStoreProvider } from "../../interfaces/store-provider.interface";
import { IFixBlockOptions } from "../../interfaces/fix-block-options.interface";
import { FixBlockMode } from "./enums/fix-block-mode.enum";
import { QuizEvent } from "./../../enums/quiz-event.enum";
import { EventEmitter } from "./../../components/event-emitter";
import { OpenTrigger } from "./../../enums/open-trigger.enum";
import { IQuiz } from './../../interfaces/quiz.interface';
import { fixBlockOptionsSchema, IFixBlockOptionsSchema } from "../../dto/fix-block-options.schema";
import { StoreProvider } from "./../../providers/store.provider";
import { FullWidgetNode } from "./components/full-widget-node";
import { MiniWidgetNode } from "./components/mini-widget-node";
import { IModule } from "../../interfaces/module.interface";
import { UAParser } from "ua-parser-js";

export default class FixBlock implements IModule {

  constructor(options: IFixBlockOptions) {
    this.options = fixBlockOptionsSchema.parse(options);

    this.store = new StoreProvider(new WidgetState());
    this.eventEmitter = new EventEmitter<WidgetEvent>(); 
    this.fullWidgetNode = new FullWidgetNode(this.options, this.eventEmitter);
    this.miniWidgetNode = new MiniWidgetNode(this.options, this.eventEmitter);
  }
  
  private mainNode: IWidgetNode;
  private quiz: IQuiz;
  private readonly store: IStoreProvider<WidgetState>;
  private readonly fullWidgetNode: IWidgetNode;
  private readonly miniWidgetNode: IWidgetNode;
  private readonly eventEmitter: EventEmitter<WidgetEvent>
  private readonly options: IFixBlockOptionsSchema;
  private readonly trigger_name = OpenTrigger.FIX_BLOCK;
  private uaParser = new UAParser();

  public readonly name = "fix-block";

  public async getData() {
    return {
      options: this.options,
      trigger_name: this.trigger_name,
      status: this.store.getState().status
    }
  }
  
  public async init(quiz: IQuiz) {
    this.quiz = quiz;

    this.fullWidgetNode.appendToPage();
    this.miniWidgetNode.appendToPage();
    this.store.updateState({ status: WidgetStatus.OPEN });

    if (this.options.hideOnBottom) {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener("scroll", this.onScroll);
    }

    if (this.options.mode == FixBlockMode.FULL) this.mainNode = this.fullWidgetNode;
      else this.mainNode = this.miniWidgetNode;
    
    this.eventEmitter.subscribe(WidgetEvent.CLOSE_WIDGET, () => this.close());
    quiz.bind(QuizEvent.ABORT, () => this.close());

    setTimeout(() => {
      this.show();
      if (this.options.showMiniWidgetFromMobile) {
        const uaData = this.uaParser.getResult();
        if (uaData.device.type == "mobile") {
          console.log("lsdkjfldsjfdjklf");
          this.fullWidgetNode.hide();
          this.miniWidgetNode.show();
        } 
      }
    }, 0);
    this.bind(WidgetEvent.CALL_QUIZ, () => this.quiz.open(this.trigger_name, this.options.initialPageIndex));
    this.quiz.bind(QuizEvent.GET_LEAD, () => this.close());
  }

  public show() {
    if (this.store.getState().status == WidgetStatus.CLOSED) return;
    this.mainNode.show();
    this.store.updateState({ status: WidgetStatus.OPEN });
  }

  public close() {
    this.mainNode.hide();
    if (this.options.mode == FixBlockMode.FULL && this.options.showMiniOnCloseFullWidget) {
      setTimeout(() => this.miniWidgetNode.show(), 200);
    }
    this.store.updateState({ status: WidgetStatus.CLOSED });
  }

  public hide() {
    this.mainNode.hide();
    this.store.updateState({ status: WidgetStatus.HIDDEN });
  }

  public bind(event: WidgetEvent, callback: (e:any) => void) {
    return this.eventEmitter.subscribe(event, callback);
  }

  public unbind(event: WidgetEvent, callback: (e:any) => void) {
    return this.eventEmitter.unsubscribe(event, callback);
  }

  public on(event: QuizEvent) {
    switch (event) {
      case QuizEvent.OPEN: {
        if (this.options.hideOnQuizOpen) this.close();
        break;
      }
    }
  }

  private onScroll() {
    const { pageYOffset, innerHeight } = window;

    if (this.store.getState().status == WidgetStatus.CLOSED) {
      return window.removeEventListener("scroll", this.onScroll);
    }

    if (pageYOffset + innerHeight * 1.1 >= document.body.offsetHeight) this.hide();
      else this.show();
  }
}